// Display when no date is selected.
export const EMPTY_DATE_DISPLAY = "dd/mm/yy";
